export const formatCurrency = (amount = 0) => `R${Number(amount || 0).toLocaleString("en-ZA").replace(/[\s\u00A0,]+/g, " ")}`;